import { Either } from 'src/utils/either';

import { httpResponseHandler } from 'src/http/http-response-handler';

import {
  HttpTypes,
  BadRequestError,
  ConnectionError,
  UnexpectedError,
  AccessDeniedError,
  InternalServerError,
  TooManyRequestsError,
} from '../../http';
import { endpoints } from 'src/utils/axios';
import { CreateAndUpdateAdmType } from 'src/types/users';

export class AdmsRepository {
  constructor(private api: HttpTypes.HttpClient) {}

  async getAdmsList(): Promise<
    Either<
      | BadRequestError
      | UnexpectedError
      | InternalServerError
      | AccessDeniedError
      | ConnectionError
      | TooManyRequestsError,
      any | undefined
    >
  > {
    const request: HttpTypes.HttpRequest = {
      method: 'get',
      url: endpoints.users.admList,
    };

    const response = await this.api.request(request);

    return httpResponseHandler(response);
  }

  async deleteAdms(
    emails: string[]
  ): Promise<
    Either<
      | BadRequestError
      | UnexpectedError
      | InternalServerError
      | AccessDeniedError
      | ConnectionError
      | TooManyRequestsError,
      any | undefined
    >
  > {
    const request: HttpTypes.HttpRequest = {
      method: 'delete',
      url: endpoints.users.deleteAdms,
      body: {
        emails,
      },
    };

    const response = await this.api.request(request);

    return httpResponseHandler(response);
  }

  async createAdm(
    adm: CreateAndUpdateAdmType
  ): Promise<
    Either<
      | BadRequestError
      | UnexpectedError
      | InternalServerError
      | AccessDeniedError
      | ConnectionError
      | TooManyRequestsError,
      any | undefined
    >
  > {
    const request: HttpTypes.HttpRequest = {
      method: 'post',
      url: endpoints.users.createAdm,
      body: adm,
    };

    const response = await this.api.request(request);

    return httpResponseHandler(response);
  }

  async updateAdm(
    adm: CreateAndUpdateAdmType
  ): Promise<
    Either<
      | BadRequestError
      | UnexpectedError
      | InternalServerError
      | AccessDeniedError
      | ConnectionError
      | TooManyRequestsError,
      any | undefined
    >
  > {
    const request: HttpTypes.HttpRequest = {
      method: 'put',
      url: endpoints.users.updateAdm,
      body: adm,
    };

    const response = await this.api.request(request);

    return httpResponseHandler(response);
  }

  async getAdmToEdit(
    userId: string
  ): Promise<
    Either<
      | BadRequestError
      | UnexpectedError
      | InternalServerError
      | AccessDeniedError
      | ConnectionError
      | TooManyRequestsError,
      any | undefined
    >
  > {
    const request: HttpTypes.HttpRequest = {
      method: 'get',
      url: endpoints.users.admToEdit,
      params: {
        userId,
      } as any,
    };

    const response = await this.api.request(request);

    return httpResponseHandler(response);
  }

  async changeUserHome(
    userId: string,
    home: string
  ): Promise<
    Either<
      | BadRequestError
      | UnexpectedError
      | InternalServerError
      | AccessDeniedError
      | ConnectionError
      | TooManyRequestsError,
      any | undefined
    >
  > {
    const request: HttpTypes.HttpRequest = {
      method: 'put',
      url: endpoints.users.changeUserHome,
      params: {
        userId,
        home
      } as any,
    };

    const response = await this.api.request(request);

    return httpResponseHandler(response);
  }
}
